// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideSettings2 as RawLucideSettings2 } from "lucide-react";
export const LucideSettings2 = /* @__PURE__ */ createIcon(RawLucideSettings2, "LucideSettings2", 2);
